import { i18n } from '@lingui/core';

export const locales = {
  'en-us': {
    label: 'English (US)',
    importResource: () => import('@/locales/en-US.po'),
  },
  'de-de': {
    label: 'Deutsch (DE)',
    importResource: () => import('@/locales/de-DE.po'),
  },
  'es-mx': {
    label: 'Español (MX)',
    importResource: () => import('@/locales/es-MX.po'),
  },
  'fr-fr': {
    label: 'Français (FR)',
    importResource: () => import('@/locales/fr-FR.po'),
  },
  'pt-br': {
    label: 'Português (BR)',
    importResource: () => import('@/locales/pt-BR.po'),
  },
  'it-it': {
    label: 'Italiano (IT)',
    importResource: () => import('@/locales/it-IT.po'),
  },
  'ja-jp': {
    label: '日本語 (JP)',
    importResource: () => import('@/locales/ja-JP.po'),
  },
};

export type LocaleType = keyof typeof locales;

export const DEFAULT_LOCALE = 'en-us';

/**
 * Loads the language and sets it as the active language
 * @param locale - The locale to load
 */
export async function lazySetLanguage(locale: LocaleType) {
  const { messages } = await locales[locale].importResource();
  i18n.load(locale, messages);
  i18n.activate(locale);
}
